<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <EntitySettingsTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model="entity.title"
                            label="Название"
                            placeholder="Введите название сервиса"
                        />
                        <CTextarea
                            v-model="entity.title_formatted"
                            label="Подпись для главной"
                            placeholder="Введите подпись"
                        />
                        <CInput
                            v-model="entity.code"
                            label="Код"
                            placeholder="Введите код сервиса"
                        />
                        <CInput
                            v-model="entity.color"
                            label="Цвет"
                            placeholder="Введите цвет сервиса"
                        />
                        <CInput
                            v-model="entity.gradient"
                            label="Градиент"
                            placeholder="Введите градиент сервиса"
                        />
                        <CInput
                            v-model="entity.icon"
                            label="Иконка (Пример: cil-basket, ресурс:  https://iconify.design/icon-sets/cil/)"
                            placeholder="Введите код иконки"
                        />
                        <CInputFile
                            ref="picture"
                            label="Картинка сервиса в приложении"
                            horizontal
                            @change="selectPicture"
                        />
                        <CInputFile
                            ref="largePicture"
                            label="Картинка сервиса на сайте"
                            horizontal
                            @change="selectLargePicture"
                        />
                        <CRow v-if="pictureMainPageUrl" class="mb-3">
                            <CCol sm="3" class="text-right">
                                <label class="col-form-label">Текущая картинка для главной (большая):</label>
                            </CCol>
                            <CCol sm="9">
                                <CImg
                                    :src="pictureMainPageUrl"
                                    class="m2"
                                    width="200"
                                />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="pictureMainPage"
                            label="Картинка для главной (большая)"
                            horizontal
                            @change="selectPictureMainPage"
                        />
                        <CRow v-if="pictureMainPageSqUrl" class="mb-3">
                            <CCol sm="3" class="text-right">
                                <label class="col-form-label">Текущая картинка для главной (маленькая):</label>
                            </CCol>
                            <CCol sm="9">
                                <CImg
                                    :src="pictureMainPageSqUrl"
                                    class="m2"
                                    width="200"
                                />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="pictureMainPageSq"
                            label="Картинка для главной (маленькая)"
                            horizontal
                            @change="selectPictureMainPageSq"
                        />
                        <CCard class="p-3">
                            <CRow>
                                <CCol style="display: flex; align-items: center;">
                                    <span>Данные для аналитики</span>
                                    <CSwitch
                                        class="ml-3"
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="entity.analytics_data"
                                    />
                                </CCol>
                            </CRow>
                            <CRow v-show="entity.analytics_data">
                                <CCol>
                                    <div>
                                        <CRow>
                                            <CCol style="display: flex; justify-content: space-between; align-items: center;">
                                                <span><b>Значения</b></span>
                                                <CButton color="primary" @click="addAnalyticsValue">
                                                    Добавить
                                                </CButton>
                                            </CCol>
                                        </CRow>
                                        <template v-for="(item, index) in entity.analytics_data_values">
                                            <CRow :key="`analytics_data_value-${index}`">
                                                <CCol>
                                                    <CInput
                                                        v-model="item.title"
                                                        placeholder="Введите значение"
                                                        @input="setAnalyticsValue(index, $event)"
                                                    />
                                                </CCol>
                                                <CCol>
                                                    <CButton color="danger" @click="removeAnalyticsValue(index)">
                                                        Удалить
                                                    </CButton>
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCard>
                        <CRow style="margin-top: 6px">
                            <span class="ml-3">Активно (десктоп)</span>
                            <CSwitch
                                class="ml-3"
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="entity.enabled"
                            />
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                    <CButton
                        v-if="adminOnly"
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true"
                    >Удалить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите удалить сервис? Это действие
                        нельзя будет отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteSerivce"
                    >Удалить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import EntitySettingsTabLinks from '@/components/entities/EntitySettingsTabLinks';

    export default {
        name: 'EntityTypeEdit',

        components: {
            EntitySettingsTabLinks,
        },

        data() {
            return {
                entity: {
                    id: 0,
                    title: '',
                    code: '',
                    color: '',
                    gradient: '',
                    picture: '',
                    large_picture: '',
                    picture_main_page: '',
                    picture_main_page_sq: '',
                    icon: '',
                    analytics_data: false,
                    analytics_data_values: [],
                    enabled: true,
                },
                selectedPicture: null,
                selectedLargePicture: null,
                selectedPictureMainPage: null,
                selectedPictureMainPageSq: null,
                deleteModal: false,
            };
        },

        computed: {
            pictureUrl() {
                if (this.entity.picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.picture
                    );
                } else {
                    return '';
                }
            },
            largePictureUrl() {
                if (this.entity.large_picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.large_picture
                    );
                } else {
                    return '';
                }
            },
            pictureMainPageUrl() {
                if (this.entity.picture_main_page) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.picture_main_page
                    );
                } else {
                    return '';
                }
            },
            pictureMainPageSqUrl() {
                if (this.entity.picture_main_page_sq) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.picture_main_page_sq
                    );
                } else {
                    return '';
                }
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get('/entities-type/' + id)
                .then(resp => {
                    this.entity = {
                        ...this.entity,
                        ...resp.data
                    };
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
            selectLargePicture(FileList) {
                this.selectedLargePicture = FileList[0];
            },
            selectPictureMainPage(FileList) {
                this.selectedPictureMainPage = FileList[0];
            },
            selectPictureMainPageSq(FileList) {
                this.selectedPictureMainPageSq = FileList[0];
            },

            addAnalyticsValue() {
                let maxId = 0;

                if(!this.entity.analytics_data_values) {
                    this.entity.analytics_data_values = [];
                }
                for(const item of this.entity.analytics_data_values) {
                    if(item.id > maxId) {
                        maxId = item.id;
                    }
                }
                
                this.entity.analytics_data_values.push({
                    id: maxId + 1,
                    title: ''
                });
            },
            removeAnalyticsValue(index) {
                this.entity.analytics_data_values.splice(index, 1);
            },
            async setAnalyticsValue(index, value) {
                this.entity.analytics_data_values[index].title = value;
            },

            async save() {
                if (!this.entity.title) {
                    this.$root.$emit('showError', 'Укажите название сервиса.');
                    return;
                }
                if (!this.entity.code) {
                    this.$root.$emit('showError', 'Укажите код сервиса.');
                    return;
                }
                if (!this.entity.color) {
                    this.$root.$emit('showError', 'Укажите цвет сервиса.');
                    return;
                }
                if (!this.entity.gradient) {
                    this.$root.$emit('showError', 'Укажите градиент сервиса.');
                    return;
                }

                try {
                    let formData = new FormData();

                    if (this.selectedLargePicture) {
                        formData.append('file', this.selectedLargePicture);
                        const largePictureName = await Vue.axios.post('/files/upload', formData);
                        this.entity.large_picture = largePictureName.data.filename;
                    }

                    if (this.selectedPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedPicture);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.entity.picture = uploadPicture.data.filename;
                    }

                    if (this.selectedPictureMainPage) {
                        formData = new FormData();
                        formData.append('file', this.selectedPictureMainPage);
                        const uploadPictureMainPage = await Vue.axios.post('/files/upload', formData);
                        this.entity.picture_main_page = uploadPictureMainPage.data.filename;
                    }

                    if (this.selectedPictureMainPageSq) {
                        formData = new FormData();
                        formData.append('file', this.selectedPictureMainPageSq);
                        const uploadPictureMainPageSq = await Vue.axios.post('/files/upload', formData);
                        this.entity.picture_main_page_sq = uploadPictureMainPageSq.data.filename;
                    }

                    await Vue.axios.post(`/entities-type/update/${this.$route.params.id}`, this.entity);

                    this.goBack();
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                } finally {
                    this.$store.dispatch('fetchSidebarData');
                }
            },

            deleteSerivce() {
                Vue.axios
                    .delete('/entities-type/delete/' + this.entity.id)
                    .then(() => {
                        this.$router.push({ path: '/settings/entities/' });
                    })
                    .catch(err => this.$root.$emit('showError', 'Ошибка удаления.'))
                    .finally(() => this.$store.dispatch('fetchSidebarData'));
            },

            goBack() {
                this.$router.push({
                    path: '/settings/entities/' + this.$route.params.id,
                });
            },
        },
    };
</script>
